import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Button as ButtonComponent, RoundedWrapper, Typography } from '@raisin/components-lib';

export const BankDetailsHeaderContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(8),
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    gap: theme.spacing(4),
    justifyContent: 'flex-start',
  },
}));

export const BankDetailsInfoContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
});

export const BankDetailsInfo = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  flex: 1,
  justifyContent: 'center',
  minWidth: 420,
});

export const BankDetailsInfoLayout = styled(Box)(({ theme }) => ({
  padding: theme.spacing(6, 6, 0, 0),
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(8, 0, 0, 0),
  },
}));

export const BackButtonContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    paddingBottom: theme.spacing(6),
  },
}));
export const BankNameTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(6),
  [theme.breakpoints.down('lg')]: {
    fontSize: theme.typography.h4.fontSize,
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(4),
  },
}));

export const Button = styled(ButtonComponent)({
  justifyContent: 'left',
});

export const BackButton = styled(Button)(({ theme, hidden }) => ({
  display: 'inline-flex',
  margin: 'auto',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'left',
  },

  ...(hidden && {
    visibility: 'hidden',
  }),
}));

export const LogoContainer = styled(RoundedWrapper)(({ theme }) => ({
  width: 516,
  height: 516,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(29.5, 24.5, 24.5, 29.5),
  '& img': {
    objectFit: 'contain',
  },
  [theme.breakpoints.down('lg')]: {
    padding: 51,
    width: 382,
    height: 382,
  },
}));
